import { animate, animation, keyframes, style } from "@angular/animations";

export const runTimer = animation([
    animate('60s linear', keyframes([
        style({ strokeDashoffset: '{{strokeDashoffset_start}}', offset: 0}),
        style({ strokeDashoffset: '{{strokeDashoffset_end}}', offset: 1}),
    ]))
])